// Vendor libraries
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { StoreModule } from '@ngrx/store';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { FormsModule } from '@angular/forms';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { NavigationModule } from 'NewAngular/features/components/navigation/navigation.module';
import { PopoverModule } from 'NewAngular/features/directives/popovers/popover/popover.module';
import { SimplePaginationControlsModule } from 'NewAngular/features/components/pagination/simple-pagination-controls/simple-pagination-controls.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
// NgRx reducers
import { rootReducer } from './search-all.store';
// Component imports
import { getLogger } from 'NewAngular/state/logger';
import { SearchAllPageComponent } from './components/search-all-page/search-all-page.component';
import { TopBarNavComponent } from 'NewAngular/features/components/navigation/top-bar-nav/top-bar-nav.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ngrx/store";
export class AppModule {
}
AppModule.ɵfac = function AppModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || AppModule)(); };
AppModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: AppModule, bootstrap: [SearchAllPageComponent, TopBarNavComponent] });
AppModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule,
        FormsModule,
        TooltipModule,
        ConfigModule,
        IconModule,
        NavigationModule,
        PopoverModule,
        RouterModule.forRoot([], { useHash: true }),
        SimplePaginationControlsModule,
        StoreModule.forRoot({ reducers: rootReducer }, { metaReducers: getLogger() })] });
